import App from '@/models/App'

export default class SelectShipJob extends App {
    static get entity() {
        return 'SelectShipJobs'
    }
    static all() {
        return this.query().get()
    }
    static findByCode(code) {
        return this.query().where('value', code).first()
    }
    static fields() {
        return {
            id: this.attr(''),
            value: this.attr(''),
            ja: this.attr(''),
            en: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/env/select/ship/job`, {
                    params: {},
                    headers: {
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
